export default "__VITE_ASSET__B0gccTwA__"